import axios from '@/libs/api.request'

export const getDictionaryList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/dict'
  })
}

export const addDictionary = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/dict'
  })
}

export const editDictionary = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/dict'
  })
}

export const delDictionary = (id) => {
  return axios.request({
    method: 'delete',
    url: '/dict/' + id
  })
}

export const getDictionaryInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/dict/' + id
  })
}
